module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Ladder-42b0306dc1ca89210f6b261a50d18b7b89d23a58931e322d3d4e273d3972cca4.svg";